import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {ProjectOffHoldDialogModel, ProjectOffHoldIncrementModel} from "./project-off-hold.model";

@Component({
  templateUrl: "./project-off-hold-dialog.template.pug",
})
export class ProjectOffHoldDialogComponent
  extends DialogComponent<ProjectOffHoldDialogModel, ProjectOffHoldIncrementModel>
  implements ProjectOffHoldDialogModel {
  public error: Error;
  public projectName: string;
  public message: string;

  public units: string = "weeks";
  public increment: number = 0;

  static showCreateDialog(
    dialogService: DialogService,
    inputs: ProjectOffHoldDialogModel,
  ): Observable<ProjectOffHoldIncrementModel> {
    return dialogService.addDialog(
      ProjectOffHoldDialogComponent,
      inputs,
      {backdropColor: "rgba(0, 0, 0, 0.5)"},
    );
  }

  cancel(): void {
    this.result = null;
    this.close();
  }

  @handleErrors()
  async finish(): Promise<void> {
    if (this.increment > 0) {
      this.result = {units: this.units, increment: this.increment};
    } else {
      this.result = {units: this.units, increment: 0};
    }
    this.close();
  }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
  }
}
